import React from 'react';
import CurrencyFormat from 'react-currency-format';
import PropTypes from 'prop-types';
import Lang from "lang.js";
import messages from "../../js/messages";
const lang = new Lang({messages, fallback: "nl"});

const NumericInput = ({
                          className,
                          id,
                          name,
                          disabled,
                          value,
                          placeholder,
                          thousandSeparator,
                          decimalSeparator,
                          decimalScale,
                          readOnly,
                          onValueChange,
                          prepend,
                          append,
                          displayType,
                          fixedDecimalScale,
                          label,
                          noLabel,
                          maxValue,
                          autoComplete,
                          error
                      }) => {

    let formatted_value = '';
    if (!!value || value === 0) {
        formatted_value = value.toString().replace('.', ',');
    }

    return (
        <CurrencyFormat
            id={!!id ? id : name}
            onValueChange={(all) => {
                onValueChange({
                    ...all,
                    floatValue: isNaN(all.floatValue) ? '' : all.floatValue,
                })
            }}
            isAllowed={(values) =>{
                if(!!maxValue){
                    return values.floatValue <= maxValue;
                }
                return true
            }}
            className={className}
            name={name}
            label={label}
            disabled={disabled}
            customInput={CustomInput}
            error={error}
            value={formatted_value}
            placeholder={placeholder}
            thousandSeparator={thousandSeparator}
            decimalSeparator={decimalSeparator}
            decimalScale={decimalScale}
            type={decimalScale === 0 ? 'tel' : 'text'}
            readOnly={readOnly}
            append={append}
            prepend={prepend}
            fixedDecimalScale={fixedDecimalScale}
            autoComplete={autoComplete}
            displayType={displayType}
            noLabel={noLabel}
            renderText={(value) => <TextInput value={value} append={append}
                                              prepend={prepend}/>}
        />
    );
};

NumericInput.propTypes = {
    id: PropTypes.string,
    className: PropTypes.string.isRequired,
    onValueChange: PropTypes.func,
    displayType: PropTypes.oneOf(['text', 'input']),
    noLabel: PropTypes.bool
};

NumericInput.defaultProps = {
    className: 'form-control',
    decimalScale: 0,
    thousandSeparator: '.',
    decimalSeparator: ',',
    disabled: false,
    readOnly: false,
};

export default NumericInput;

//when displayType={'input'} this component will be shown this is the default
const CustomInput = ({
                         id,
                         type,
                         className,
                         name,
                         onChange,
                         value,
                         placeholder,
                         disabled,
                         readOnly,
                         prepend,
                         append,
                         label,
                         noLabel,
                         autoComplete,
                         error
                     }) => {

    return (
        <div className={`form-group ${!noLabel ? 'mb-2' : 'my-0'}`}>
            {!noLabel &&
            <label className="mb-1" htmlFor={!!id ? id : name}>{!!label ? label : lang.get('portal.' + name)}:</label>
            }
            <div className="input-group">
                {prepend && <div className="input-group-prepend">
                    <span className="input-group-text">{prepend}</span>
                </div>}
                <input id={!!id ? id : name}
                       type={type}
                       className={`${className} ${!!error && 'is-invalid'}`}
                       name={name}
                       value={value}
                       readOnly={readOnly}
                       disabled={disabled}
                       onChange={onChange}
                       placeholder={!!placeholder ? placeholder : lang.get('portal.' + name)}
                       autoComplete={autoComplete}
                       required=""/>
                {append && <div className="input-group-append">
                    <span className="input-group-text">{append}</span>
                </div>}
            </div>
            <span className="invalid-feedback" style={{display: 'block'}} role="alert">
                    <strong>{error}</strong>
             </span>
        </div>
    )
}

//when displayType={'text'} this component will be shown
const TextInput = ({value, prepend, append}) => {
    return (<span>
            {prepend && prepend + ' '}{value}{append}
            </span>
    )
}
